import { Avatar } from '@material-ui/core'
import React, { useState, useEffect } from 'react';
import classes from './Post.module.css'
import { motion } from 'framer-motion'
import { db, auth, timeStamp } from '../firebaseConfig';
import { useAuth } from '../Context/AuthContext'

function Post(props) {
    const [comment, setComment] = useState('')
    const [comments, setComments] = useState([])
    const [loading, setLoading] = useState(false)
    const { loggedIn } = useAuth();
    useEffect(() => {
        let unsubscribe
        if (props.id) {
            unsubscribe = db.collection('images').doc(props.id).collection('comments').orderBy('createdAt', 'desc')
                .onSnapshot((snap) => {
                    setComments(snap.docs.map((doc) => doc.data()))
                })
        }
        return () => {
            unsubscribe();
        }
    }, [props.id])
    async function submitHandler(e) {
        e.preventDefault()
        if (!comment) {
            return alert("please add comment first")
        }
        setLoading(true)

        let createdAtTime = timeStamp();
        await db.collection('images').doc(props.id).collection('comments').add({
            name: auth.currentUser.displayName,
            comment: comment,
            createdAt: createdAtTime
        })


        const inputForm = document.getElementById('form1')
        inputForm.reset();
        inputForm.childNodes[1].value = ''


        setComment('')

        setLoading(false)
    }

    return (
        <motion.div className={classes.div} layout initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div className={classes.head}>
                <div><Avatar classname={classes.avatar}>{props.name[0].toUpperCase()}</Avatar></div>

                <h4>{props.name}</h4>
            </div>
            <div className={classes.image}>
                <motion.img src={props.url} initial={{ opacity: 0 }} animate={{ opacity: .9 }} whileHover={{ opacity: 1 }} />
            </div>
            <p className={classes.caption}><strong>Caption:</strong>  {props.caption}</p>
            <div className={classes.loadComment}>
                <h4 style={{ color: 'white', backgroundColor: '' }}>Comments</h4>
                {comments.slice(0, 2).map((comm) => (
                    <p className={classes.para1} key={Math.random(10000000)} style={{
                        color
                            : 'white'
                    }} ><strong style={{ color: 'white' }}>{comm.name}:</strong>{comm.comment}</p>
                ))}
            </div>
            {  (auth.currentUser && loggedIn) && <form id="form1" className={classes.inputComment} id="form1" >
                <input type="text" id="inputext" onChange={(e) => setComment(e.target.value)} onFocus={(e) => e.target.value = ""} placeholder="comment" />
                <button type="submit" className={classes.comment} disabled={loading} onClick={submitHandler}>Comment</button>
            </form>}
        </motion.div>
    )
}

export default Post
